
import React, { useEffect, useState } from "react";
import "./Screen.css";
import { TypeAnimation } from "react-type-animation";
import { Link } from "react-router-dom";

import img1 from "../assets/2.png";
import img2 from "../assets/6.png";
import img3 from "../assets/7.png";
import img4 from "../assets/8.png";

const images = [img4, img3, img2, img1];

function Screen() {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const scrollStep = () => {
    window.scrollBy({
      top: window.innerHeight,
      behavior: "smooth",
    });
  };

  return (
    <section className="hero" dir="rtl">
      {images.map((img, index) => (
        <div
          key={index}
          className={`hero-slide ${index === currentImage ? "active" : ""}`}
          style={{
            backgroundImage: `url(${img})`,
          }}
          aria-hidden="true"
        />
      ))}

      <div className="overlay"></div>

      <div className="hero-content" dir="rtl">
        <span className="hero-badge">
          אתרי תדמית • חנויות אונליין • דפי נחיתה • אתרים בהתאמה אישית
        </span>

        <h1>
          מקימים לעסק שלך
          <br />
          אתר שמביא לקוחות
        </h1>

        <TypeAnimation
          sequence={[
            "אתר תדמית מקצועי לעסק שלך",
            2000,
            "עיצוב מודרני שמייצר אמון",
            2000,
            "מהיר, רספונסיבי ומותאם לנייד",
            2000,
            "פתרון איכותי גם לעסקים קטנים",
            2000,
          ]}
          speed={60}
          repeat={Infinity}
          className="typing-text"
        />

        <div className="hero-buttons" dir="rtl">
          <Link
            onClick={scrollStep}
            to="/Contact"
            className="btn-primary"
          >
            תשאלו אותנו
          </Link>

          <Link
            onClick={scrollStep}
            to="/Mysite"
            className="btn-secondary"
          >
            האתרים שלנו
          </Link>
        </div>

        <button
          type="button"
          className="scroll-down"
          onClick={scrollStep}
          aria-label="גלילה להמשך העמוד"
        >
          <svg
            width="42"
            height="42"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M6 9l6 6 6-6"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </section>
  );
}

export default Screen;
